import PropTypes from "prop-types"
import Icon from "components/planning_center_icon"
import { columnsPropTypes } from "components/ui/Table/tablePropsTypes"
import { css } from "@emotion/core"
import { colors } from "components/shared/admin_colors"

const TableRowHeader = ({
  columns = [],
  isDraggable = false,
  isSelectable,
  onSort = null,
  sortBy = null,
  sortDir = null
}) => {
  const buttonStyle = css`
    cursor: pointer;
    font-size: inherit;
    text-transform: inherit;
    font-weight: inherit;
    letter-spacing: inherit;
    color: inherit;
    text-align: inherit;
    &:hover > .sort-icon {
      visibility: visible;
      color: var(--t-fill-color-neutral-030);
    }
  `

  const renderSortHeader = column => (
    <button css={buttonStyle} className="table-sorter-button" onClick={e => onSort(e, column)}>
      {column.hideHeaderLabel ? (
        <span className="screen-reader-text">{column.label}</span>
      ) : (
        column.label
      )}
      <div className={`sort-icon ml-1 d-i p-r t-2p ${column.cell === sortBy ? "v-v" : "v-h"}`}>
        <Icon
          symbol={`general#${sortBy === column.cell && sortDir === "desc" ? "down" : "up"}-caret`}
        />
      </div>
    </button>
  )

  return (
    <thead>
      <tr>
        {isDraggable && (
          <th>
            <span className="screen-reader-text">Drag control</span>
          </th>
        )}
        {isSelectable && (
          <th>
            <span className="screen-reader-text">Select column</span>
          </th>
        )}
        {columns.map(column => (
          <th
            key={column.cell}
            className={`${column.isSortable && "table-sorter"} ${column.headerClassName ||
              column.className ||
              ""}`}
            css={column.headerStyle}
          >
            {column.isSortable && renderSortHeader(column)}
            {!column.isSortable && (
              <>
                {column.hideHeaderLabel ? (
                  <span className="screen-reader-text">{column.label}</span>
                ) : (
                  column.label
                )}
              </>
            )}
          </th>
        ))}
      </tr>
    </thead>
  )
}

TableRowHeader.propTypes = {
  columns: columnsPropTypes,
  isDraggable: PropTypes.bool,
  isSelectable: PropTypes.bool,
  onSort: PropTypes.func,
  sortBy: PropTypes.string,
  sortDir: PropTypes.string
}

export default TableRowHeader
